import template from './insurancePipelineLabelsMenu.html';
import controller from './insurancePipelineLabelsMenuCtrl.js';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    labels: '<',
    selectedLabelIds: '<',
    onAddLabel: '&',
    onUpdateLabel: '&',
    onDeleteLabel: '&',
    onAddLabelToCard: '&',
    onDeleteLabelFromCard: '&',
    onBack: '&?',
  },
};
